import { useCallback } from '@wordpress/element';
import { getCurrentPostAcfFields } from '../utils/methods';
import $ from 'jquery';

const { registerBlockType } = wp.blocks;
const {
  RichText,
  MediaUpload,
  MediaUploadCheck,
  InspectorControls,
  URLInputButton,
} = wp.blockEditor;
const { Button, PanelBody, SelectControl } = wp.components;
const { Fragment, useEffect, useState } = wp.element;
const { __ } = wp.i18n;
const { useSelect, subscribe } = wp.data;

registerBlockType('pg/course-intro', {
  title: __('PG Course Intro'),
  icon: 'welcome-learn-more',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    sectionClass: {
      type: 'string',
      default: 'section-dark-secondary',
    },
    imageUrl: {
      type: 'string',
      default:
        '/wp-content/themes/positiongreen/resources/images/placeholders/placeholder_7.png',
    },
    imageAlt: {
      type: 'string',
      default: '', // Added alt attribute for image
    },
    eyebrowText: {
      type: 'string',
      default: '',
    },
    eyebrowSpan: {
      type: 'string',
      default: '',
    },
    headingText: {
      type: 'string',
      default: '',
    },
    courseLevelText: {
      type: 'string',
      default: 'Beginner – intermediate',
    },
    suitableForText: {
      type: 'string',
      default: 'Suitable for',
    },
    estimatedTimeText: {
      type: 'string',
      default: 'Estimated time to complete',
    },
    courseEstimatedTime: {
      type: 'string',
      default: '',
    },
    courseSuitableFor: {
      type: 'string',
      default: '',
    },
    courseLevel: {
      type: 'string',
      default: 0,
    },
    buttonLink: {
      type: 'string',
      default: '#',
    },
    buttonText: {
      type: 'string',
      default: 'All courses',
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const {
      sectionClass,
      imageUrl,
      imageAlt, // Added imageAlt to edit
      eyebrowText,
      eyebrowSpan,
      headingText,
      courseLevelText,
      suitableForText,
      estimatedTimeText,
      courseEstimatedTime,
      courseSuitableFor,
      courseLevel,
      buttonLink,
      buttonText,
    } = attributes;

    const acfFields = acf.getFields();

    const postMeta =
      useSelect(
        (select) => select('core/editor').getEditedPostAttribute('meta'),
        []
      ) || [];

    useEffect(() => {
      if (postMeta) {
        if (
          postMeta.course_estimated_time !== undefined &&
          postMeta.course_estimated_time !== courseEstimatedTime
        ) {
          setAttributes({
            courseEstimatedTime: postMeta.course_estimated_time || '',
          });
        }
        if (
          postMeta.course_suitable_for !== undefined &&
          postMeta.course_suitable_for !== courseSuitableFor
        ) {
          setAttributes({
            courseSuitableFor: postMeta.course_suitable_for || '',
          });
        }
        if (
          postMeta.course_level !== undefined &&
          postMeta.course_level !== courseLevel
        ) {
          setAttributes({ courseLevel: parseInt(postMeta.course_level) || 1 });
        }
      }
    }, [postMeta]);

    const refreshMeta = useCallback(
      (event, field) => {
        event.preventDefault();
        event.stopPropagation();

        if (event.target.value === undefined) {
          return;
        }

        postMeta[field.data.name] = event.target.value;

        if (field.data.name === 'course_level') {
          setAttributes({ courseLevel: event.target.value });
          return;
        }

        if (field.data.name === 'course_suitable_for') {
          setAttributes({ courseSuitableFor: event.target.value });
          return;
        }

        if (field.data.name === 'course_estimated_time') {
          setAttributes({ courseEstimatedTime: event.target.value });
        }
      },
      [postMeta, setAttributes]
    );

    useEffect(() => {
      if (!acfFields) {
        return;
      }

      acfFields.forEach((field) => {
        $(`[name=acf\\[${field.data.key}\\]]`).on('change', (event) =>
          refreshMeta(event, field)
        );
      });

      acfFields.forEach((field) =>
        $(`[name=acf\\[${field.data.key}\\]]`).trigger('change')
      );

      return () => {
        acfFields.forEach((field) =>
          $(`[name=acf\\[${field.data.key}\\]]`).off('change')
        );
      };
    }, [acfFields]);

    const onSelectImage = (media) => {
      setAttributes({ imageUrl: media.url, imageAlt: media.alt || '' }); // Set imageAlt
    };

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    const renderDots = (level) => {
      const dots = [];
      for (let i = 0; i < 4; i++) {
        dots.push(
          <span
            key={i}
            className={`dot ${i <= level ? 'dot-dark' : 'dot-light'}`}
          ></span>
        );
      }
      return dots;
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Section Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
          </PanelBody>
        </InspectorControls>
        <section className={sectionClass}>
          <div className="corner corner-dark-secondary corner-on-light-primary corner-right-bottom"></div>
          <div className="course-intro-section-wrapper">
            <div className="content-container">
              <div className="intro-top">
                <div className="image-wrapper">
                  <MediaUploadCheck>
                    <MediaUpload
                      onSelect={onSelectImage}
                      allowedTypes={['image']}
                      value={imageUrl}
                      render={({ open }) => (
                        <Button onClick={open} isPrimary>
                          {__('Upload Image')}
                        </Button>
                      )}
                    />
                  </MediaUploadCheck>
                  {imageUrl && <img src={imageUrl} alt={imageAlt} />}{' '}
                  {/* Use imageAlt */}
                </div>
                <div className="content-wrapper">
                  <div className="eyebrow">
                    <RichText
                      tagName="e"
                      value={eyebrowText}
                      onChange={(value) =>
                        setAttributes({ eyebrowText: value })
                      }
                      placeholder={__('Eyebrow Text...')}
                    />
                    <RichText
                      tagName="span"
                      value={eyebrowSpan}
                      onChange={(value) =>
                        setAttributes({ eyebrowSpan: value })
                      }
                      placeholder={__('Eyebrow Span...')}
                    />
                  </div>
                  <RichText
                    tagName="h1"
                    value={headingText}
                    onChange={(value) => setAttributes({ headingText: value })}
                    placeholder={__('Heading Text...')}
                  />
                </div>
              </div>
              <div className="intro-bottom">
                <div className="level">
                  <RichText
                    tagName="p"
                    value={courseLevelText}
                    onChange={(value) =>
                      setAttributes({ courseLevelText: value })
                    }
                    placeholder={__('Course Level Text...')}
                  />
                  <p>{renderDots(parseInt(courseLevel))}</p>
                </div>
                <div className="purposer">
                  <RichText
                    tagName="p"
                    value={suitableForText}
                    onChange={(value) =>
                      setAttributes({ suitableForText: value })
                    }
                    placeholder={__('Suitable For Text...')}
                  />
                  <p>{courseSuitableFor}</p>
                </div>
                <div className="time">
                  <RichText
                    tagName="p"
                    value={estimatedTimeText}
                    onChange={(value) =>
                      setAttributes({ estimatedTimeText: value })
                    }
                    placeholder={__('Estimated Time Text...')}
                  />
                  <p>{courseEstimatedTime}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const {
      sectionClass,
      imageUrl,
      imageAlt, // Added imageAlt in save
      eyebrowText,
      eyebrowSpan,
      headingText,
      courseLevel,
      courseLevelText,
      suitableForText,
      estimatedTimeText,
      courseSuitableFor,
      courseEstimatedTime,
      buttonLink,
      buttonText,
    } = attributes;

    const renderDots = (level) => {
      const dots = [];
      for (let i = 0; i < 4; i++) {
        dots.push(
          <span
            key={i}
            className={`dot ${i <= level ? 'dot-dark' : 'dot-light'}`}
          ></span>
        );
      }
      return dots;
    };

    return (
      <section className={sectionClass}>
        <div className="corner corner-dark-secondary corner-on-light-primary corner-right-bottom"></div>
        <div className="course-intro-section-wrapper">
          <div className="content-container">
            <div className="intro-top">
              <div className="image-wrapper">
                {imageUrl && <img src={imageUrl} alt={imageAlt} />}{' '}
                {/* Use imageAlt */}
              </div>
              <div className="content-wrapper">
                <div className="eyebrow">
                  <RichText.Content tagName="e" value={eyebrowText} />
                  <RichText.Content tagName="span" value={eyebrowSpan} />
                </div>
                <RichText.Content tagName="h1" value={headingText} />
              </div>
            </div>
            <div className="intro-bottom">
              <div className="level">
                <RichText.Content tagName="p" value={courseLevelText} />
                <p>{renderDots(parseInt(courseLevel))}</p>
              </div>
              <div className="purposer">
                <RichText.Content tagName="p" value={suitableForText} />
                <p>{courseSuitableFor}</p>
              </div>
              <div className="time">
                <RichText.Content tagName="p" value={estimatedTimeText} />
                <p>{courseEstimatedTime}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  },
});
